import React from 'react';
import { Modal as AntModal, Image as AntImage } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    DefaultIMG,
} from "@assets";

const Modal = styled(AntModal)`

.ant-modal-content {
    padding: 30px !important;

    @media screen and (max-width: 300px) {
       padding: 30px 10px !important;
    }
}

.ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    font-size: 18px;
    font-weight: bold;
}

.ant-modal-footer {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding-top: 12px;

    .ant-btn {
        min-width: 100px;

        @media screen and (max-width: 300px) {
            min-width: 90px;
        }
    }
}
`;

const Image = styled(AntImage).attrs({
    alt: 'img',
    fallback: DefaultIMG,
    preview: false,
})`
margin-bottom: 14px;
width: 70px !important;
object-fit: cover;
aspect-ratio: 1;
border-radius: 20px;
`;

const ExitConfirmModal = ({
    open,
    confirmLoading,
    gameIcon,
    onCancel,
    onOk,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            width={320}
            confirmLoading={confirmLoading}
            open={open}
            onCancel={onCancel}
            onOk={onOk}
            okText={t("common.ok")}
            cancelText={t("common.cancel")}
        >
            <Image src={gameIcon} />
            {t("maintain.exitGameConfirmMessage")}
        </Modal>
    );
}

export default ExitConfirmModal;